import { Component, OnInit,Input } from '@angular/core';
import { GIXNGButtonsService } from '../gixngbuttons.service';

@Component({
  selector: 'gix-button-cornecto',
  templateUrl: './gix-button-cornecto.component.html',
  styleUrls: ['./gix-button-cornecto.component.css']
})
export class GixButtonCornectoComponent implements OnInit {
 


  @Input() txt?: string;
  //@STCGoal It Increases its Width according to the Text Input ; STATE: germinating

  @Input() icon?: string;


   @Input() color?:string;

   
  iconValue: string;
  constructor(public gIXNGButtonsService:GIXNGButtonsService) {


    if (!this.icon) this.icon = "add";

    //does some mapping of common name
    if (this.icon) {
      console.log(this.icon);
      this.iconValue =  this.gIXNGButtonsService.getEasyNaming(this.icon);
      console.log("Button icon:" +this.icon + '/'+ this.iconValue);
    }

    //default value for buttons/icon
    if (!this.txt)
      this.txt = "create";

    if (!this.color)this.color = "primary";
  }

  ngOnInit() {
  }

}
